import { useCallback, useEffect, useState } from 'react';
import { useOptionalUserId } from '@/lib/auth';
import {
  loadRecentCourseIds,
  rememberRecentCourseId,
  saveRecentCourseIds,
} from '@/lib/recentCourseSelections';

/**
 * Forløb this user picked on Vælg forløb, newest first.
 * Stored per user and clinic. Nothing here selects a course.
 */
export function useRecentCourseSelections(clinicId: string) {
  const userId = useOptionalUserId();
  const [recentIds, setRecentIds] = useState<string[]>(() =>
    userId ? loadRecentCourseIds(userId, clinicId) : [],
  );

  useEffect(() => {
    if (!userId) {
      setRecentIds([]);
      return;
    }
    setRecentIds(loadRecentCourseIds(userId, clinicId));
  }, [clinicId, userId]);

  const remember = useCallback(
    (templateId: string) => {
      if (!userId) return;
      setRecentIds((current) => {
        const next = rememberRecentCourseId(current, templateId);
        saveRecentCourseIds(userId, clinicId, next);
        return next;
      });
    },
    [clinicId, userId],
  );

  return { recentIds, remember };
}
